export default import.meta.ROLLDOWN_FILE_URL_SFOMHmdMR9FSYKLoOZoe5Q